import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { TncComponent } from 'src/modules/base/components/tnc/tnc.component';
import { LoaderService } from 'src/modules/base/services/loader.service';

@Component({
    selector: 'kx-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  timer: number;
  headerInfo: any = {};
  registerUser: boolean = false
  showTimer: boolean = false;
  disableOtp: boolean = false;
  show: boolean = false;
  login_id: any;
  eulaList: any = false;
  eye: string = "fa-eye";
  eye1: string = "fa-eye";
  submitted = false;
  submitted_forgot: boolean = false;
  forgotPasswordForm: FormGroup;
  ResetsetOpt: any = false;
  forgotPasswordFormOTP: FormGroup;
  isKarexpert: string = '';
  checkPattern: any = '^[a-zA-Z0-9!@#$&()\\-`.+_,/\"-]*$'
  image_captcha: any;
  showOtpComponent: boolean = false;
  @ViewChild('changeOtpBtn') changeOtpBtn: any;
  superApps: Array<any>[];

  constructor(
    private alertService: AlertsService,
    private baseService: BaseService,
    private router: Router,
    private formBuilder: FormBuilder,
    private appService: AppService,
    private domSanitizer: DomSanitizer,
    private translateService: TranslateService,
    private modalService: SmartModalService,
    private sanitizer: DomSanitizer,
    public utilService: UtilService,
    private loader: LoaderService
  ) {
  }

  ngOnInit() {
    this.superApps = this.appService._currentSessionData.superApps;
    this.headerInfo = this.appService.getAppHeader();
    if (this.headerInfo.eula_document_links != undefined && this.headerInfo.eula_document_links.length > 0) {
      this.appService.parseEula(this.headerInfo.eula_document_links);
      this.eulaList = this.appService.getEula();
    }

    this.headerInfo.login_tag = this.headerInfo.login_tag.changingThisBreaksApplicationSecurity == undefined ? this.sanitizer.bypassSecurityTrustHtml(this.headerInfo.login_tag) : this.headerInfo.login_tag;
    if (this.headerInfo.android_app_url != undefined) {
      this.headerInfo.android_app_url = this.domSanitizer.bypassSecurityTrustUrl(this.headerInfo.android_app_url);
    }
    if (this.headerInfo.ios_app_url != undefined) {
      this.headerInfo.ios_app_url = this.domSanitizer.bypassSecurityTrustUrl(this.headerInfo.ios_app_url);
    }
    if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost') {
      this.forgotPasswordForm = this.formBuilder.group({
        login_id: ['', Validators.required],
        account_url: ['']
      });

      this.forgotPasswordFormOTP = this.formBuilder.group({
        password: ['', Validators.required],
        confirm_password: ['', Validators.required],
        captcha: ['', Validators.required]
      });
    } else {
      this.isKarexpert = 'karexpert';
      this.forgotPasswordForm = this.formBuilder.group({
        login_id: ['', Validators.required],
        account_url: ['', Validators.required]
      });

      this.forgotPasswordFormOTP = this.formBuilder.group({
        password: ['', Validators.required],
        confirm_password: ['', Validators.required],
        captcha: ['', Validators.required]
      });
    }
    this.disableOtp = true;
  }

  get f() { return this.forgotPasswordForm.controls; } // return form

  get fp() { return this.forgotPasswordFormOTP.controls; }

  onLoginid() {
    let loginid = this.forgotPasswordForm.controls['login_id'].value;
    if (loginid) {
      this.disableOtp = false;
    } else {
      this.disableOtp = true;
    }
  }

  otp: string;
  // showOtpComponent = true;
  @ViewChild('ngOtpInput') ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };
  clear() {
    this.ResetsetOpt = true;
  }
  generateOTP() {
    this.loader.showSpinner()
    this.submitted = true;
    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      this.loader.hideSpinner()
      return;
    }
    let account_url: string = ''
    this.login_id = this.forgotPasswordForm.controls['login_id'].value;
    if (this.isKarexpert != '') {
      account_url = this.forgotPasswordForm.controls['account_url'].value;
    } else {
      account_url = window.location.hostname;
    }

    let args = 'login_id:' + this.login_id + ',account_url:' + account_url + ',context:forget_password';
    this.baseService.get('send_otp', args, 'send_otp', 'account-management').subscribe(res => {
      this.loader.hideSpinner()
      if (res.errCode == -1) {
        this.alertService.error(res.message);
      } else if (res.errCode == 0) {
        this.showOtpComponent = true;
        // this.show = false
        this.alertService.success('Success', res.message);
        this.timer = 59;
        this.showTimer = true;
        let timerInterval = setInterval(() => {
          this.timer -= 1;
          if (this.timer <= 0) {
            clearInterval(timerInterval);
            this.showTimer = false;
          }
        }, 1000)
      }
      // }
    })
  }

  onOtpChange(event: any) {
    this.otp = event;
    if (this.otp.length != 6) {
      this.changeOtpBtn.nativeElement.disabled = true;
    } else {
      this.changeOtpBtn.nativeElement.disabled = ""
    }
    this.ResetsetOpt = false;
  }

  verifyOtp() {
    var account_url
     if (this.isKarexpert != '') {
       account_url = this.forgotPasswordForm.controls['account_url'].value;
     } else {
       account_url = window.location.hostname;
     }

     var accountURL = account_url.split('.');
      if (accountURL[0].length < 16) {
        accountURL[0] = accountURL[0] + "0000000000000000".substring(0, (16 - accountURL[0].length));
      } else {
        accountURL[0] = accountURL[0].substring(0, 16);
      }
     let args = 'login_id:' + this.appService.encryptText(accountURL[0],this.login_id) + ',account_id:' + account_url + ',context:forget_password,otp_no:' + this.appService.encryptText(accountURL[0],this.otp);
     this.baseService.get("VERIFY_OTP_FORGOT_PASSWORD", args, "otp", "account-management").subscribe((result: any) => {
       if (result.errCode == 0) {
         this.alertService.success("");
        this.generateCaptcha()
       } else {
         this.alertService.error(result.message);
       }
     })
  }

  generateCaptcha(eve?) {
    let account_url: string = ''
    if (this.isKarexpert != '') {
      account_url = this.forgotPasswordForm.controls['account_url'].value;
    } else {
      account_url = window.location.hostname;
    }
    let body = { "login_id": this.login_id, "account_url": account_url }
    this.baseService.add(body, "captcha_store", true, "account-management", "generate_captcha").subscribe((res: any) => {
      if (res.errCode == -1) {
        this.alertService.error(res.message)
      } else if (res.errCode == 0) {
        this.image_captcha = "data:image/jpeg;base64, " + res.resource[0].img_captcha;
        this.showOtpComponent = false;
        this.showTimer = false;
        this.forgotPasswordFormOTP.controls['captcha'].setValue("")
        if (eve == undefined) {
          this.show = true;
        }
      }
    })
  }

  passwordValidator() {
    let pass = this.forgotPasswordFormOTP.controls['password'].value;
    let cpass = this.forgotPasswordFormOTP.controls['confirm_password'].value;
    if (pass !== cpass) {
      this.forgotPasswordFormOTP.controls['confirm_password'].setErrors({ 'incorrect': true });
      this.forgotPasswordFormOTP.controls['confirm_password'].dirty;
      this.forgotPasswordFormOTP.controls['confirm_password'].errors;
    //  this.generateCaptcha(true)

    } else {
      this.forgotPasswordFormOTP.controls['confirm_password'].setErrors({ 'incorrect': false });
      this.forgotPasswordFormOTP.controls['confirm_password'].markAsPristine();
      this.forgotPasswordFormOTP.controls['confirm_password'].updateValueAndValidity();
    }
  }

  forgotPassword() {
    this.loader.showSpinner()
    this.submitted_forgot = true;
    // stop here if form is invalid
    if (this.forgotPasswordFormOTP.invalid) {
      this.loader.hideSpinner()
      return;
    }
    let otp = this.otp;
    let pass = this.forgotPasswordFormOTP.controls['password'].value;
    let cpass = this.forgotPasswordFormOTP.controls['confirm_password'].value;
    let account_url: string = '';
    if (this.isKarexpert != '') {
      account_url = this.forgotPasswordForm.controls['account_url'].value;
    } else {
      account_url = window.location.hostname;
    }

    if (pass === cpass) {
      console.log('password and confirm password are same');

      this.forgotPasswordForm.patchValue({
        account_url: account_url
      });
      // this.forgotPasswordForm['account_url'] = account_url;
      // console.log('form values ==>>', this.forgotPasswordForm.getRawValue());
      let value = {
        otp_no: this.otp,
        password: this.forgotPasswordFormOTP.controls['password'].value,
        confirm_password: this.forgotPasswordFormOTP.controls['confirm_password'].value,
        login_id: this.forgotPasswordForm.controls['login_id'].value,
        captcha: this.forgotPasswordFormOTP.controls['captcha'].value,
        account_url: account_url
      }
      // data, 'self_registration', false, 'patient-registration'
      this.baseService.add(value, 'forget_password', true, 'account-management').subscribe(res => {
        this.loader.hideSpinner()
        if (res.errCode == -1) {
          this.alertService.error(res.message);
          this.forgetpasswordformreset()
          this.generateCaptcha()  // wrong captcha automatically refresh
        } else if (res.errCode == 0) {
          this.alertService.success('Password Updated', 'Successfully');
          this.router.navigate(['/login']);
        }
      })
    } else {
      this.loader.hideSpinner()
      console.log('password not matched');
      this.alertService.error('Password and Confirm Password must be same', 'Password Mismatch')
    }
  }

  languageChange(value) {
    this.translateService.setLanguage(value, () => {
      window.location.reload();
    });
  }

  selfRegistration() {
    this.registerUser = true;
  }

  showTnc() {
    console.log('show tnc clicked');
    this.modalService.open(TncComponent, '', 'Terms of Service and Data Privacy Notice', ModalSize.Lg, 'center', true).subscribe(res => {
      if (res) {
        console.log('tnc modal closed');
      }
    }, err => {
      console.error('error occured in tnc modal', err);
    })
  }
  forgetpasswordformreset()
  {
    this.forgotPasswordFormOTP.controls['password'].reset();
    this.forgotPasswordFormOTP.controls['confirm_password'].reset();
  }

  backToLogin(event) {
    if (event.back == true || event.set_password == true)
      this.registerUser = false
  }
  backToForgotPass() {
    this.showOtpComponent = false;
  }

  backToReset() {
    this.show = false;
  }


  navigateToLogin() {
    console.log('forgot password clicked');
    this.router.navigate(['/login']);
  }
}
